import { get } from "lodash";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { AppLogo, Button } from "../../../atoms";
import HamburgerMenu from "../../../atoms/hamburger-menu";
import { getCardByAttribute, getStoryElementBySubType } from "../../../utils";
import "./Header.m.css";

const getHeaderMenuSections = (headerMenuItems) => {
  return headerMenuItems
    .map((item) => {
      const element = document.getElementById(item.toLowerCase());
      if (element) {
        const rect = element.getBoundingClientRect();
        return {
          id: item.toLowerCase(),
          top: rect.top + window.scrollY - 100,
          bottom: rect.bottom + window.scrollY - 100,
        };
      }
      return null;
    })
    .filter(Boolean);
};

export const Header = ({ sections }) => {
  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const headerMenuItems = get(qtState, ["data", "headerMenuItems"], []);
  const eventStory = get(qtState, ["data", "eventStory"], {});
  const cards = get(eventStory, ["cards"], []);
  const menuButtonCard = getCardByAttribute(cards, "cardtype", "Menu - Button");
  const ctaElement = getStoryElementBySubType(menuButtonCard, "text", "cta");
  const ctaTitle = get(ctaElement, ["metadata", "cta-title"], "");
  const ctaUrl = get(ctaElement, ["metadata", "cta-url"], "");
  const openInNewTab = get(ctaElement, ["metadata", "open-in-new-tab"], false);
  const hamburgerItems = headerMenuItems.map((item) => {
    return {
      title: item,
      completeUrl: `#${item.toLowerCase()}`,
    };
  });
  const [isHamburgerMenuOpen, setIsHamburgerMenuOpen] = useState(false);
  const toggleHandler = () => {
  const headerState = !isHamburgerMenuOpen;
  setIsHamburgerMenuOpen(headerState);

  document.body.classList.toggle("no-scroll-forSummary", headerState);
};
  const [activeSection, setActiveSection] = useState("");

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;

      // Find the section that is currently in view
      const currentSection = getHeaderMenuSections(headerMenuItems).find(
        // Check if the scroll position is within the section's top and bottom
        (section) => scrollPosition >= section.top && scrollPosition < section.bottom
      );

      if (currentSection) {
        setActiveSection(currentSection.id);
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [headerMenuItems]);
  return (
    <div styleName="custom-event-header">
      <div styleName="desktop-header">
        <div styleName="logo-container">
          <AppLogo customStyle="app-logo-header" />
        </div>
        <div styleName="navigation-links">
          {headerMenuItems.map((item, index) => (
            <div key={index} styleName="nav-item">
              <a
                styleName={`nav-link ${activeSection === item.toLowerCase() ? "active" : ""}`}
                href={`#${item.toLowerCase()}`}
              >
                {item}
              </a>
              <div styleName={`horizontal-divider ${activeSection === item.toLowerCase() ? "active" : ""}`} />
            </div>
          ))}
          {ctaUrl && ctaTitle && (
            <div styleName="button-wrapper">
              <Button customStyleName="bg-brand-primary" href={ctaUrl} openInNewTab={openInNewTab}>
                {ctaTitle}
              </Button>
            </div>
          )}
        </div>
      </div>
      <div styleName="mobile-header">
        <div styleName="mobile-nav">
          <div styleName={"menu-icon"} onClick={() => toggleHandler()}>
            <HamburgerMenu
              onMenuToggle={() => toggleHandler()}
              isMegaMenuOpen={isHamburgerMenuOpen}
              hamburgerMenu={hamburgerItems}
              disableSearch={true}
              ctaButton={
                ctaUrl && ctaTitle ? (
                  <Button customStyleName="bg-brand-primary" href={ctaUrl} openInNewTab={openInNewTab}>
                    {ctaTitle}
                  </Button>
                ) : null
              }
            />
          </div>
          <div styleName="logo-container">
            <AppLogo customStyle="app-logo-header" />
          </div>
          {ctaUrl && ctaTitle && (
            <Button customStyleName="bg-brand-primary" href={ctaUrl} openInNewTab={openInNewTab}>
              {ctaTitle}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

Header.propTypes = {
  sections: PropTypes.array,
};
